import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as c, openBlock as d, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const r = {
  name: "DtIconSlack",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, o = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ a("path", {
  d: "M6.202 14.639c0 1.156-.945 2.1-2.101 2.1A2.106 2.106 0 0 1 2 14.64c0-1.157.945-2.101 2.101-2.101h2.101v2.1Zm1.058-.001c0-1.156.945-2.1 2.102-2.1 1.156 0 2.1.944 2.1 2.1V19.9A2.106 2.106 0 0 1 9.363 22a2.106 2.106 0 0 1-2.101-2.101v-5.26Z",
  fill: "#E01E5A"
}, null, -1), h = /* @__PURE__ */ a("path", {
  d: "M9.362 6.202A2.106 2.106 0 0 1 7.26 4.101C7.26 2.945 8.205 2 9.36 2c1.157 0 2.101.945 2.101 2.101v2.101h-2.1Zm0 1.058c1.156 0 2.1.945 2.1 2.102 0 1.156-.944 2.1-2.1 2.1H4.1A2.106 2.106 0 0 1 2 9.363c0-1.157.945-2.101 2.101-2.101h5.26Z",
  fill: "#36C5F0"
}, null, -1), m = /* @__PURE__ */ a("path", {
  d: "M17.798 9.362c0-1.157.945-2.101 2.101-2.101 1.156 0 2.101.944 2.101 2.1a2.106 2.106 0 0 1-2.101 2.101h-2.101v-2.1Zm-1.058 0c0 1.156-.945 2.1-2.102 2.1a2.106 2.106 0 0 1-2.1-2.1V4.1c0-1.156.944-2.101 2.1-2.101 1.157 0 2.101.945 2.101 2.101v5.26Z",
  fill: "#2EB67D"
}, null, -1), u = /* @__PURE__ */ a("path", {
  d: "M14.638 17.798c1.157 0 2.101.945 2.101 2.101A2.106 2.106 0 0 1 14.64 22a2.106 2.106 0 0 1-2.102-2.101v-2.1h2.101Zm0-1.058a2.106 2.106 0 0 1-2.1-2.101c0-1.157.944-2.101 2.1-2.101H19.9c1.156 0 2.1.944 2.1 2.1a2.105 2.105 0 0 1-2.1 2.101h-5.26Z",
  fill: "#ECB22E"
}, null, -1), f = [
  _,
  h,
  m,
  u
];
function p(t, v, l, E, Z, e) {
  return d(), c("svg", {
    "aria-label": l.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--slack"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Slack",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, o);
}
const g = /* @__PURE__ */ n(r, [["render", p]]);
export {
  g as default
};
//# sourceMappingURL=slack.js.map
